module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-1-e833834b75b6db181fcce100fed55cfb.jpg";